import { useEffect, useState } from 'react';
import { Space, Switch, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReloadOutlined } from '@ant-design/icons';

import { Button, Select } from 'components';

import useIntervalSelectOptions from './hooks/useIntervalSelectOptions';

import { IRefreshActionsProps } from './RefreshActions.types';

const { Text } = Typography;

const RefreshActions = ({ onRefresh }: IRefreshActionsProps) => {
  const { t } = useTranslation();

  const options = useIntervalSelectOptions();

  const [autorefresh, setAutorefresh] = useState<boolean>(false);
  const [intervalId, setIntervalId] = useState<ReturnType<typeof setInterval> | null>(null);
  const [intervalMs, setIntervalMs] = useState<number>(options[0].value);

  const onAutoRefreshChange = (value: boolean) => {
    if (value) {
      const newIntervalId = setInterval(onRefresh, intervalMs);
      setIntervalId(newIntervalId);
    } else {
      if (intervalId) {
        clearInterval(intervalId);
      }
      setIntervalId(null);
    }

    setAutorefresh(value);
  };

  const onIntervalChange = (ms: number) => {
    setIntervalMs(ms);
    if (intervalId) {
      clearInterval(intervalId);
    }

    const newIntervalId = setInterval(onRefresh, ms);
    setIntervalId(newIntervalId);
  };

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);

  return (
    <Space size={24}>
      <Space>
        <Switch checked={autorefresh} onChange={onAutoRefreshChange} />
        <Text>{t('form.button.autorefresh')}</Text>
      </Space>

      <Select
        type="primary"
        value={intervalMs}
        options={options}
        popupMatchSelectWidth={false}
        onSelect={onIntervalChange}
        disabled={!autorefresh}
        style={{ width: 120 }}
      />

      <Button size="small" icon={<ReloadOutlined />} onClick={onRefresh}>
        {t('form.button.refresh')}
      </Button>
    </Space>
  );
};

export default RefreshActions;
